import { render, staticRenderFns } from "./YoukeLaiyuanFenxi.vue?vue&type=template&id=642f38fc&scoped=true&"
import script from "./YoukeLaiyuanFenxi.vue?vue&type=script&lang=js&"
export * from "./YoukeLaiyuanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f38fc",
  null
  
)

export default component.exports